import { Tooltip } from '@material-ui/core';
import React from 'react';
import useTranslations from '../../../../hooks/useTranslations';
import Disabler from '../../../Disabler';
import InputBase from '../../../form/InputBase';
import styled from 'styled-components';

const InputWrapper = styled.span`
  display: flex;
  flex: 0.95;
`;

const Mask = styled.div`
  z-index: 20;
  display: ${({ $enabled }) => ($enabled ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background: red;
`;

const SendWebhookView = props => {
  const t = useTranslations();

  return (
    <>
      <Mask $enabled={props.isMaskEnabled} />
      <Tooltip
        arrow
        title={
          props.disabled
            ? t('automaions.wizard.actions.webhook.disabled.tooltip')
            : ''
        }
      >
        <InputWrapper>
          <InputBase
            disabled={props.disabled}
            value={props.webhookURL}
            onChange={e => props.setWebhookURL(e.target.value)}
            variant={props.variant}
            onFocus={props.onWebhookInputFocus}
            onBlur={props.onWebhookInputBlur}
            error={props.inputErrMsg}
            placeholder={t('automation.webhook.input.placeholder')}
            customCSS={`z-index: 21 !important; margin-left: 0.8rem !important; align-self: center; & > div { max-height: 34px !important; }`}
          />
        </InputWrapper>
      </Tooltip>
    </>
  );
};

export default SendWebhookView;
